import axios from 'axios';
import {
    SET_ALLOWED_ROOMS,
    SET_ALLOWED_USERS,
    SET_PERIOD,
    SET_RESERVATIONS,
    SET_UPCOMING,
} from '../constants/mutations';

const state = {
    allowed_rooms: [],
    allowed_users: [],
    reservations: [],
    upcoming: [],
    period: null,
};

const getters = {
    allowed_rooms: (state) => state.allowed_rooms,
    allowed_users: (state) => state.allowed_users,
    period: (state) => state.period,
    reservations: (state) => state.reservations,
    upcoming: (state) => state.upcoming,
};

const actions = {
    getAllowedRoomsAsync({ commit, dispatch, state }, period) {
        commit(SET_PERIOD, period);
        period = period ?? state.period;
        axios
            .get('/admin/rooms', { params: { period_id: period } })
            .then((res) => {
                commit(SET_ALLOWED_ROOMS, _.sortBy(res.data, 'room_name'));
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    getAllowedUsersAsync({ commit, dispatch, state }, period) {
        period = period ?? state.period;
        axios
            .get('/admin/allowed-users', { params: { period_id: period } })
            .then((res) => {
                commit(
                    SET_ALLOWED_USERS,
                    res.data.map((u) => {
                        return { ...u, new_neptun: u.neptun };
                    })
                );
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    getReservationsAsync({ commit, dispatch, state }, period) {
        period = period ?? state.period;
        axios
            .get('/admin/reservations', { params: { period_id: period } })
            .then((res) => {
                commit(
                    SET_RESERVATIONS,
                    res.data.map((e) => ({
                        ...e,
                        system_reserve: e?.last_modified_by === 'system',
                    }))
                );
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    storeRoomAsync({ commit, state, dispatch }, room) {
        axios
            .post(`/api/admin/allowed_rooms/`, { ...room })
            .then((res) => {
                commit(SET_ALLOWED_ROOMS, [...state.allowed_rooms, res.data]);
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    storeReservationAsync({ dispatch, state }, reservation) {
        axios
            .post(`/api/admin/reservations/`, { ...reservation })
            .then((res) => {
                dispatch('getReservationsAsync', reservation.period_id);
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    updateReservationAsync({ state, dispatch }, reservation) {
        axios
            .patch(`/api/admin/reservations/${reservation.id}`, { ...reservation })
            .then((res) => {
                dispatch('getReservationsAsync', reservation.period_id);
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    deleteReservationAsync({ dispatch, state }, reservation) {
        axios
            .delete(`/api/admin/reservations/${reservation.id}`, { ...reservation })
            .then((res) => {
                dispatch('getReservationsAsync', reservation.period_id);
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    deleteRoomAsync({ state, dispatch }, { id }) {
        axios
            .delete(`/api/admin/allowed_rooms/${id}`)
            .then((res) => {
                dispatch('getAllowedRoomsAsync', state.period);
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    updateAllowedUser({ state, dispatch }, payload) {
        axios
            .patch(`/api/admin/allowed_users/`, payload)
            .then((res) => {
                dispatch('getAllowedUsersAsync');
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    getUpcomingPeriodAsync({ commit, dispatch }) {
        axios
            .get('/upcoming-periods')
            .then((res) => {
                commit(SET_UPCOMING, res.data);
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    closeUpcomingPeriod({ commit, state }, period) {
        commit(
            SET_UPCOMING,
            state.upcoming.filter((p) => p.name !== period.name)
        );
    },
    sendSystemReserveNotification({}, period) {
        axios.post('/api/admin/email/system-notify', { period_id: period }).then((res) => {});
    },
    sendAllowedUserNotification({}, period) {
        axios.post('/api/admin/email/allowed-notify', { period_id: period }).then((res) => {});
    },
};

const mutations = {
    [SET_PERIOD](state, payload) {
        state.period = payload;
    },
    [SET_ALLOWED_ROOMS](state, payload) {
        state.allowed_rooms = payload;
    },
    [SET_ALLOWED_USERS](state, payload) {
        state.allowed_users = payload;
    },
    [SET_RESERVATIONS](state, payload) {
        state.reservations = payload;
    },
    [SET_UPCOMING](state, payload) {
        state.upcoming = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
